import React from 'react'
import {Link} from 'react-router-dom'
// Components
import {Form, Button} from 'semantic-ui-react'
import styles from './style.module.css'


export default function ForgottenPassword({ history }) {

  return (
    <div className={styles.root}>

      <div className={styles.content}>

        <h2>Forgotten password</h2>

        <Form onSubmit={() => history.push('/login')}>

          <Form.Field>
            <Form.Input
              required
              icon="mail"
              iconPosition="left"
              label="Email"
              placeholder="Enter email"
              size="large"
            />
          </Form.Field>

          <Form.Group widths="equal">
            <Form.Field>
              <Button type="submit">Submit</Button>
            </Form.Field>
            <Form.Field className={styles.textRight}>
              <Link to="/">Go back</Link>
            </Form.Field>
          </Form.Group>

        </Form>

      </div>

    </div>
  )

}
